import React, { FC } from 'react'
import { PieChart as RechartsPieChart, Pie, Legend, Tooltip, Cell } from 'recharts'


interface IPieChartComponentProps {
    data: {
        name: string
        value: number
        fill: string
    }[]
   
}

const PieChartComponent: FC<IPieChartComponentProps> = ({  data, }) => {

    // Calcula o total para obter a porcentagem
    const total = data.reduce((sum, item) => sum + item.value, 0)

    const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
        const { name, value } = payload[0].payload
        const percentage = ((value / total) * 100).toFixed(2) + '%'

        return (
        <div style={{ background: 'white', padding: 8, border: '1px solid #ccc', borderRadius: 4 }}>
            <p>{name}: {percentage}</p>
        </div>
        )
    }
    return null
    }

  return (
    <RechartsPieChart width={600} height={400}>
      <Pie data={data} dataKey="value" nameKey="name" cx="40%" cy="50%" outerRadius={150}>
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.fill} />
        ))}
      </Pie>
      <Tooltip content={<CustomTooltip />} />
      <Legend verticalAlign="top" align="right" layout="vertical" />
    </RechartsPieChart>
  )
}

export { PieChartComponent }
